/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, useEffect} from 'react'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {TournamentsPayload} from '../../../../../../api/models/response/TournamentsPayload'
import {ChampionshipPayload} from '../../../../../../api/models/response/ChampionshipPayload'
import {formatNumberWithCommas} from '../../../../../../utilitites/formatNumber'

type Props = {
  item: ChampionshipPayload
}

const CoinCell: FC<Props> = ({item}) => {
  const formattedNumber = formatNumberWithCommas(item?.coins)

  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <span>
          <img
            src={require('../../../../../../assets/images/Coin.png')}
            style={{width: '20px'}}
            alt='coin'
          />{' '}
          {formattedNumber}
        </span>
      </div>
    </div>
  )
}
export {CoinCell}
